<template>
  <v-app id="app">
    <original-header />
    <router-view />
    <original-footer />
  </v-app>
</template>

<script>
import OriginalHeader from '@/components/common/header.vue'
import OriginalFooter from '@/components/common/footer.vue'

export default {
  components: { OriginalHeader, OriginalFooter },
  mounted () {}
}
</script>

<style lang="scss">
@import '@/assets/sass/color.scss';

html {
  font-size: 10px !important;
}

#app {
  font-family: 'YuMincho', 'Yu Mincho', 'Avenir', Helvetica, Arial, sans-serif;
  color: $black_color;
  background-color: $white_color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: $black_color;
  text-decoration: none;
  outline: none;
}
</style>
